export const types = {
  OPEN_NEST_MODULE: 'common/drawers/createNestingDrawer/OPEN_NEST_MODULE',
  CLOSE_NEST_MODULE: 'common/drawers/createNestingDrawer/CLOSE_NEST_MODULE',
  SET_ACTIVE_TAB_INDEX:
    'common/drawers/createNestingDrawer/SET_ACTIVE_TAB_INDEX',
};

type OpenModalProps = {
  quoteId: number;
  quoteNumber: number;
};

export const modal = {
  open: ({ quoteId, quoteNumber }: OpenModalProps) => {
    return {
      type: types.OPEN_NEST_MODULE,
      payload: { quoteId, quoteNumber },
    };
  },
  close: () => ({
    type: types.CLOSE_NEST_MODULE,
  }),
  setActiveTabIndex: (activeTabIndex: number) => {
    return {
      type: types.SET_ACTIVE_TAB_INDEX,
      payload: { activeTabIndex },
    };
  },
};
